export const FETCH_ADD_SPECIAL_TASK_REQUEST = 'FETCH_ADD_SPECIAL_TASK_REQUEST'
export const FETCH_ADD_SPECIAL_TASK_SUCCESS = 'FETCH_ADD_SPECIAL_TASK_SUCCESS'
export const FETCH_ADD_SPECIAL_TASK_FALUIRE = 'FETCH_ADD_SPECIAL_TASK_FALUIRE'
export const FETCH_LIST_FORMATTED_PROJECT_TEMPLATE_LIST_SUCCESS='FETCH_LIST_FORMATTED_PROJECT_TEMPLATE_LIST_SUCCESS'
